<template>
  <a-modal
    title="打印余额余项"
    width="1000px"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @cancel="handleCancel"
  >
    <div ref="print" id="printContent">
      <div class="text">尊敬的客户您好！请您确认您的余额余项</div>
      <div class="flex-row">
        <div>会员编号</div>
        <div>{{ state.customerObj.code }}</div>
        <div>会员姓名</div>
        <div>{{ state.customerObj.name }}</div>
        <div>手机号</div>
        <div>{{ state.customerObj.phone }}</div>
        <div>顾问</div>
        <div>{{ state.customerObj.adviser__name }}</div>
      </div>
      <div  class="text">余额(含赠金)
        <span style="padding-left: 45px">
          {{ Math.trunc(state.customerObj.wallet.real_money+state.customerObj.wallet.void_money) }}
        </span>
      </div>
      <a-table
        :scroll="false"
        :columns="state.columns"
        row-key="id"
        :data-source="state.dataSource"
        :pagination="false"
      >
        <template #end_date="{ text, record }">
          {{record.used_status!==undefined && record.used_status===0?'未激活':text}}
        </template>
      </a-table>
      <div class="flex-row">
        <div>
          <span  class="text">确认时间:</span>
          <span  class="text" style="padding-left: 60px;">{{ state.time }}</span>
        </div>
        <div  class="text"></div>
        <div  class="text"></div>
      </div>
      <div class="flex-row">
        <div>
          <span  class="text">所在门店:</span>
          <span  class="text" style="padding-left: 60px;">{{ state.customerObj.shop__name }}</span>
        </div>
        <div  class="text">&nbsp;</div>
        <div  class="text">客户签字:</div>
        <div  class="text">&nbsp;</div>
      </div>
    </div>
    <template #footer>
      <a-button v-print="'#printContent'" @click="print" type="primary">打印</a-button>
      <a-button key="back" @click="handleCancel">取消</a-button>
    </template>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';
import { get_customer_detail, query_customer_remain_info_list } from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import moment from 'moment';
export default defineComponent({
  name: 'Printcustomerremainmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],

  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const loading = ref(false);
    const dataSource: Array<any> = reactive([]);
    const state = reactive({
      time:moment().format('YYYY-MM-DD HH:mm'),
      customerObj: {
        code: '',
        name: '',
        phone: '',
        adviser__name: '',
        wallet: {
          real_money: 0,
          void_money: 0,
        },
      },
      columns: [
        {
          title: '序号',
          dataIndex: '_index',
          key: '_index',
          width: 50,
        },
        {
          title: '项目',
          dataIndex: 'project_name',
          key: 'project_name',
          width: 200,
        },
        {
          title: '余次',
          dataIndex: 'now_num',
          key: 'now_num',
          width: 50,
        },
        {
          title: '到期时间',
          dataIndex: 'end_date',
          key: 'end_date',
          width: 150,
          slots: { customRender: 'end_date' },
        },
      ],
      dataSource: dataSource,
    });
    onMounted(() => {
      loadData();
    });

    const loadData = () => {
      get_customer_detail({
        org_id: current_org.id,
        customer_id: props.obj.customer_id,
      }).then((res: any) => {
        Object.assign(state.customerObj, res.customer);
        Object.assign(state.customerObj.wallet, res.customer_wallet);
      });
      query_customer_remain_info_list({
        org_id: current_org?.id,
        customer_ids: props.obj.customer_id,
        shop_id: current_shop?.id,
        pageSize:4000,
      }).then((res: any) => {
        dataSource.length = 0;
        res.data.map((item: any) => {
          dataSource.push(item);
        });
        message.success('查询成功');
      });
    };

    const handleCancel = () => {
      emit('cancel');
    };
    const handleQuery = () => {
      loadData();
    };
    return {
      message,
      loading,
      state,
      handleCancel,
      handleQuery,
    };
  },
});
</script>

<style lang="less" scoped>
.flex-row {
  display: flex;
  justify-content: space-between;
}
.row {
  display: flex;
}
.text{
  padding:2px 0 2px 0;
}
/* 去掉页眉和页脚样式开始 */
@page {
  margin: 7mm;  /* auto is the initial value */
  margin: 7mm;  /* t
  size: auto; rgin in the printer settings */
}

html {
  margin: 7px; or: #FFFFFF;
  margin: 7px;  //* this affects the margin on the html
  background-color: #ffffff;
}

body {
  margin: 10mm 15mm 10mm 15mm; rgin: 10mm 15mm 10mm 15mm; //* margin
  border: solid 1px blue;
}
/* 去掉页眉和页脚样式结束 */
</style>
